import React, { useContext } from "react";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import './index.css';
import { informativeIcon, successIcon, warningIcon, errorIcon } from "../../assets";

const modalAlertTypes = {
  informative: {
    icon: informativeIcon,
    color: '#4D4AF5',
  },
  success: {
    icon: successIcon,
    color: '#22C55E',
  },
  warning: {
    icon: warningIcon,
    color: '#F59E0B',
  },
  error: {
    icon: errorIcon,
    color: '#EF4444',
  },
};

const ModalAlert = () => {
  const { modalAlert, setModalAlert } = useContext(ModalAlertContext);

  if (!modalAlert) return null;

  const modalAlertType = modalAlertTypes[modalAlert.type] || modalAlertTypes.informative;

  return (
    <div className={`modal-alert ${modalAlert.position === "vertical" ? "modal-alert-vertical" : ""}`}>
      <div className={`modal-alert-content`} style={{ background: modalAlertType.color }}>

        <div className="modal-alert-header-icon">
          <img src={modalAlertType.icon} alt="modal-alert-icon" />
        </div>

        <div className="modal-alert-content-inner" >
          {modalAlert.icon && (
            <img src={modalAlert.icon} className="modal-alert-content-icon" alt="modal-alert-icon" />
          )}

          <div className="modal-alert-content-texts">
            <div className="modal-alert-content-title">
              {modalAlert.title}
            </div>

            <div className="modal-alert-content-description">
              {modalAlert.message}
            </div>
          </div>

          <div className={`modal-alert-footer ${modalAlert.position === "vertical" ? "modal-alert-footer-vertical" : ""}`}>
            {modalAlert.onCancel && (
              <button className="modal-alert-footer-button button-cta button-cta-medium" onClick={() => modalAlert.onCancel()}>
                <span>{modalAlert.cancelText}</span>
              </button>
            )}
            {modalAlert.onConfirm && (
              <button className="modal-alert-footer-button button-cta-secondary button-cta-secondary-medium" onClick={() => modalAlert.onConfirm()}>
                <span>{modalAlert.confirmText}</span>
              </button>
            )}
          </div>

          {modalAlert.footer && (
            <div className="modal-alert-footer-footer">
              {modalAlert.footer}
            </div>
          )}

        </div>

      </div>
    </div>
  );
};

export default ModalAlert;
